// extracted by mini-css-extract-plugin
module.exports = {"Alert":"Alert_Alert__1004E","Open":"Alert_Open__1pv0a","Close":"Alert_Close__ck6Ob","ErrorTitle":"Alert_ErrorTitle__3Uug8"};